import React from 'react'
import PropTypes from 'prop-types'
import Column from '../../../bootstrap/component/Column'
import Row from '../../../bootstrap/component/Row'
import ContentBox from '../../../layout/component/ContentBox'
import moment from 'moment'
import currentUserHasAccess from '../../../../util/widget-helper'
import { TREATMENT_EXECUTION_WIDGET_CONTAINER } from '../../../process/ui-definition/process-ui'

const HOURS_WORN = {
    1: '1 - 22 hours or more',
    2: '18-21 hours',
    3: 'less than 18 Stunden',
}

const ALIGNER_PRESSURE = {
    0: 'very weak',
    1: 'weak',
    2: 'somewhat weak',
    3: 'medium',
    4: 'strong',
    5: 'very strong',
}

// const META_DATA_KEYS = {
//     'hoursWore': 'hours worn',
//     'alignerPressureBegin': 'pressure at the beginning',
//     'alignerPressureEnd': 'pressure at the end',
//     'alignerChangeDate': 'change date',
// }

// const formatValue = (key, value) => {
//     switch (key) {
//         case 'hoursWore':
//             return HOURS_WORN[value]
//         case 'alignerPressureBegin':
//         case 'alignerPressureEnd':
//             return ALIGNER_PRESSURE[value]
//         default:
//             return value
//     }
// }
//
// const formatKey = (key) => {
//     return META_DATA_KEYS[key] || key
// }


// const AlignerCheckInMetaData = ({ metaData }) => {
//     let keyList = Object.keys(metaData)
//
//     return (
//         <table>
//             <tbody>
//             {keyList.map((key, index) => {
//                 return (
//                     <tr key={index}>
//                         <td>{formatKey(key)}</td>
//                         <td>{formatValue(key, metaData[key])}</td>
//                     </tr>)
//             })}
//             </tbody>
//         </table>)
// }


const AlignerCheckIn = ({ alignerCheckIn }) => {
    const meta = alignerCheckIn.metaData || {}

    const alignerChangeDateOld = moment.utc(meta.alignerChangeDate, 'DD.MM.YYYY', true)
    const alignerChangeDateNew = moment.utc(meta.alignerChangeDate)
    const alignerChangeDate = alignerChangeDateOld.isValid() ? alignerChangeDateOld : alignerChangeDateNew

    const checkinDate = moment.utc(alignerCheckIn.checkinDate)

    return (<tr>
        <td>{alignerChangeDate.format('YYYY-MM-DD HH:mm')}</td>
        <td>{checkinDate.format('YYYY-MM-DD HH:mm')}</td>
        <td>{alignerCheckIn.alignerNumberLower}</td>
        <td>{alignerCheckIn.alignerNumberUpper}</td>
        <td>{alignerCheckIn.newAlignerNumberLower}</td>
        <td>{alignerCheckIn.newAlignerNumberUpper}</td>
        <td>{HOURS_WORN[meta.hoursWore]}</td>
        <td>{ALIGNER_PRESSURE[meta.alignerPressureBegin]}</td>
        <td>{ALIGNER_PRESSURE[meta.alignerPressureEnd]}</td>
    </tr>)
}


const TreatmentExecution = ({ customer }) => {
    if (!currentUserHasAccess(TREATMENT_EXECUTION_WIDGET_CONTAINER)) {
        return null
    }

    if (!customer.treatmentExecutionList || !customer.treatmentExecutionList.length) {
        return null
    }

    const alignerCheckins = customer.treatmentExecutionList.reduce((previous, current) => previous.concat(current.alignerCheckInList), [])

    return (
        <ContentBox title="Treatment Execution">
            <Row>
                <Column>
                    <table className="customer-form-table">
                        <thead>
                            <tr>
                                <th>Aligner Change Date</th>
                                <th>Checkin date</th>
                                <th>Lower</th>
                                <th>Upper</th>
                                <th>New Lower</th>
                                <th>New Upper</th>
                                <th>Hours worn</th>
                                <th>Pressure Begin</th>
                                <th>Pressure End</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                alignerCheckins.map((checkIn, index) => {
                                    return <AlignerCheckIn key={index} alignerCheckIn={checkIn}/>
                                })
                            }
                        </tbody>
                    </table>
                </Column>
            </Row>
        </ContentBox>
    )
}


TreatmentExecution.propTypes = {
    customer: PropTypes.object,
}

export default TreatmentExecution



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/TreatmentExecution.js